import { DirectJob, CreateDirectJobData } from '../types/directJob';
import apiClient from './client';

export async function createDirectJob(data: CreateDirectJobData): Promise<DirectJob> {
  const response = await apiClient.post<DirectJob>('/DirectJob', data);
  return response.data;
}

export async function getMyDirectJobs(): Promise<DirectJob[]> {
  const response = await apiClient.get<DirectJob[]>('/DirectJob/mine');
  return response.data;
}

export async function getDirectJobById(id: number): Promise<DirectJob> {
  const response = await apiClient.get<DirectJob>(`/DirectJob/${id}`);
  return response.data;
}

export async function getDirectJobModerationQueue(): Promise<DirectJob[]> {
  const response = await apiClient.get<DirectJob[]>('/DirectJob/moderation-queue');
  return response.data;
}

export async function approveDirectJob(id: number): Promise<DirectJob> {
  const response = await apiClient.put<DirectJob>(`/DirectJob/${id}/approve`, {});
  return response.data;
}

export async function rejectDirectJob(id: number, reason: string): Promise<DirectJob> {
  const response = await apiClient.put<DirectJob>(`/DirectJob/${id}/reject`, { reason });
  return response.data;
}

export async function withdrawDirectJob(id: number): Promise<DirectJob> {
  const response = await apiClient.put<DirectJob>(`/DirectJob/${id}/withdraw`, {});
  return response.data;
}

export async function acceptDirectJob(id: number): Promise<DirectJob> {
  const response = await apiClient.put<DirectJob>(`/DirectJob/${id}/accept`, {});
  return response.data;
}

export async function declineDirectJob(id: number, reason?: string, reopenToMarket?: boolean): Promise<DirectJob> {
  const response = await apiClient.put<DirectJob>(`/DirectJob/${id}/decline`, { reason, reopenToMarket: !!reopenToMarket });
  return response.data;
}
